module.exports = __webpack_public_path__ + "media/images/icons/filled/snippets-e0e0e6b7c766097676ebea6858030c4e.svg";